import styled from "styled-components";

export const ContainerCardInfo = styled.div`

  background-color: #E6E7E8;
  margin-bottom: 18px;
  padding: 10px;
  border-radius: 10px;

  .titleCardInfo {
    
    > svg {
      margin-right: 12px;
    }

    display: flex;
    align-items: center;
    color: black;
    font-weight: bolder;
    margin-bottom: 1px;
  }


`;
